module.exports = __webpack_public_path__ + "static/img/test.87d7a66e.png";